import { render, staticRenderFns } from "./lexus.vue?vue&type=template&id=384f0a9f&"
import script from "./lexus.vue?vue&type=script&lang=js&"
export * from "./lexus.vue?vue&type=script&lang=js&"
import style0 from "./lexus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports